<template>
  <div class='company-sidebar__resize' id='resizable'></div>
</template>

<script>
export default {
  props: [],
  data: function () {
    return {
      password: ""
    }
  },
  mounted () {

    var element = document.getElementById('company-sidebar');
    var resizer = document.getElementById('resizable');
    let root = document.documentElement;
    let lowerBounds = 225;
    let upperBounds = 400;
    let localWidth = localStorage.getItem('huduCompanySidebarWidth')

    if (localWidth) {
      root.style.setProperty('--sidebarwidth', (localWidth) + 'px');
    }

    resizer.addEventListener('mousedown', initResize, false);

    function initResize(e) {
      e.preventDefault()
      window.addEventListener('mousemove', Resize, false);
      window.addEventListener('mouseup', stopResize, false);
    }

    function Resize(e) {
      e.preventDefault()
      let width = e.clientX - element.offsetLeft;

      if (width >= lowerBounds && width <= upperBounds) {
        element.style.width = (width) + 'px';
        root.style.setProperty('--sidebarwidth', (width) + 'px');
        localStorage.setItem('huduCompanySidebarWidth', width);
      }
    }

    function stopResize(e) {
      window.removeEventListener('mousemove', Resize, false);
      window.removeEventListener('mouseup', stopResize, false);
    }
  },
  methods: {
    
  },
}
</script>

